import React, { Component } from 'react';
import random from 'lodash/random';
import shuffle from 'lodash/shuffle';
import debounce from 'lodash/debounce';

const IMAGES = [
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel1.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel10.png',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel9.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel8.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel7.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel6.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel5.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel4.jpg',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel12.png',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel11.png',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel3.png',
  'https://s3.amazonaws.com/crowdspring3-assets/marketing/letitbeat-homepagecarousel2.jpg',
];

const INTERVAL_SIZE = 100/IMAGES.length;

const MAX_IMAGE_SIZE = 250;

const ANIMATION_PERIOD = 5000;

export default class FloatingImages extends Component {
  constructor(props) {
    super(props);

    this.animating = false;

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  handleScroll = debounce((e) => {
    if (!this.animating) {
      this.animating = true;
      this.forceUpdate();
      setTimeout(() => this.animating = false, ANIMATION_PERIOD);
    }
  }, 200, { leading: true, trailing: false })

  render() {
    const shuffled = shuffle(IMAGES);

    return (
      <section className="block block-floating-images">
        <div className="row columns">
          <div className="block-header">
            <h2>Good design is good business</h2>
          </div>
        </div>
        <div className="images-container">
          { IMAGES.map((src, j) => {
              const i = shuffled.indexOf(src);
              const x = random(i*INTERVAL_SIZE - 5, Math.min((i+1)*INTERVAL_SIZE, 75));
              const y = random(0, 50, true);
              const z = random(0, 50, true);
              const zIndex = Math.ceil(100 - z);
              const size = (1 - (z/100)) * MAX_IMAGE_SIZE;
              const blur = (z/100)*3.5;

              return (
                <img key={j} src={src} className="item" style={{
                  left: `${x}%`,
                  top: `${y}%`,
                  width: `${size}px`,
                  height: `${size}px`,
                  filter: `blur(${blur}px)`,
                  zIndex
                }} />
              );
          }) }
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./marketing/components/floating_images.jsx